import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'components/ui/inputs/Input/styles';
import { useFormikContext } from 'formik';
import Radio from 'components/ui/inputs/Radio';
import ErrorMessage from 'components/ui/labels/ErrorMessage';
import { noop } from 'utilities';

const RadioGroup = ({
  id,
  labelText,
  name,
  onChange = noop,
  values,
  ...props
}) => {
  const { touched, errors } = useFormikContext();
  const hasErrors = touched && touched[name] && errors && errors[name];
  return (
    <>
      <Label>
        <span id={`radio-group-${id}`} className="label-text mb-2">
          {labelText}
        </span>
      </Label>
      <div
        role="group"
        className="d-flex flex-column"
        aria-labelledby={`radio-group-${id}`}
      >
        {Object.entries(values).map(([fieldName, value]) => (
          <Radio
            key={value}
            labelText={fieldName}
            name={name}
            onClick={e => onChange(e)}
            type="radio"
            value={value}
            data-testid={value}
            defaultChecked={props.value === value}
          />
        ))}
        {hasErrors && <ErrorMessage>{errors[name]}</ErrorMessage>}
      </div>
    </>
  );
};

RadioGroup.propTypes = {
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  // The selected value of the group. Provided by Formik
  value: PropTypes.any,
  /** One value per radio button */
  /** Key is the display name, value is the actual value */
  values: PropTypes.object,
};

export default RadioGroup;
